/**
 * Decodes HTML entities in a string (e.g. "&amp;" -> "&") using the
 * browser's native HTML parser via a textarea element.
 *
 * @param {string} text
 * @returns {string}
 */
const decodeHTMLEntities = (text) => {
  if (!text || typeof text !== "string") {
    return text;
  }
  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
};

export default decodeHTMLEntities;
